import { FormEvent, useState } from "react";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import styles from "./AddTabModal.module.scss";
import { MODALS_ENUM } from "@constants/Modals";
import Title from "@components/global/new/Title/Title";
import { useIntl } from "react-intl";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { Input } from "../new/Input/Input";
import { Button } from "antd";

export interface AddTabModalPropsI {
  submit(tabName: string, tabID: number): void;
}

interface PropsI extends CommonModalPropsI, AddTabModalPropsI {
  tabName?: string;
};

const useControl = (props: PropsI) => {
  const [tabName, setTabName] = useState(props.tabName || "");
  const [loading, setLoading] = useState(false);
  const { onSuccess } = useGlobalNotifs();
  const { ok } = makeNotifs();

  return {
    loading,
    setTabName,
    setLoading,
    submit(e: FormEvent) {
      if (tabName === "") {
        e.preventDefault();
        return;
      }
      props.submit(tabName, -1);
      onSuccess(ok.success);
      props.handleDestroy();
    }
  }
}

const AddTabModal = (props: PropsI) => {
  const ctrl = useControl(props);
  const { formatMessage } = useIntl();
  return (
    <div className={styles.modal}>
      <Title>{formatMessage({ id: props.tabName ? "modal.new_miners_tab.titleRename" : "modal.new_miners_tab.title" })}</Title>

      <form onSubmit={ctrl.submit} className={styles.content}>
        <Input
          label={formatMessage({ id: "modal.new_miners_tab.input_name" })}
          type='text'
          wrapClassName={styles.name}
          id='name'
          defaultValue={props.tabName}
          onChange={e => ctrl.setTabName((e.target as HTMLInputElement).value)}
          autoFocus
        />

        <Button loading={ctrl.loading} className={styles.btn} type="primary" htmlType="submit">
          {formatMessage({ id: props.tabName ? "modal.new_miners_tab.rename" : "modal.new_miners_tab.add" })}
        </Button>
      </form>
    </div>
  )
}

export default WithModal(MODALS_ENUM.ADD_MINERS_TABLE_TAB, AddTabModal);